module.exports = __webpack_public_path__ + "static/media/customer.09272eff.png";